// TopBar.tsx
import './TopBar.css';
import { useBrand } from 'src/branding';

const TopBar = () => {
  const brand = useBrand();
  return (
    <div className="topbar-page">
      <div className="top-text">
        <span>{brand.tagline}</span>
      </div>
      <img src={brand.logo} alt={`${brand.name} logo`} />
    </div>
  );
};

export default TopBar;
